import { Link } from 'react-router-dom';
import { UserPlus } from 'lucide-react';
import { Button, Card, CardContent } from '@/components/ui';
import { useTenantPrimaryColor } from '@/contexts/AcademyBrandingContext';

interface OrgMembershipsSectionProps {
  orgPath: (subpath: string) => string | null;
  membershipJoinAvailable: boolean;
  membershipsEntitled: boolean;
}

export function OrgMembershipsSection({
  orgPath,
  membershipJoinAvailable,
  membershipsEntitled,
}: OrgMembershipsSectionProps) {
  const accent = useTenantPrimaryColor();

  if (!membershipsEntitled || !membershipJoinAvailable) return null;

  const joinPath = orgPath('/join');
  const membershipPath = orgPath('/membership');

  return (
    <section aria-labelledby="memberships-heading" className="space-y-4">
      <h2 id="memberships-heading" className="text-2xl font-bold text-foreground">
        Memberships
      </h2>
      <Card>
        <CardContent className="flex flex-col items-start justify-between gap-4 p-5 sm:flex-row sm:items-center">
          <div className="flex items-start gap-3">
            <UserPlus className="mt-0.5 h-6 w-6 shrink-0" style={{ color: accent }} aria-hidden />
            <div>
              <h3 className="text-lg font-semibold text-foreground">Join the club</h3>
              <p className="mt-1 text-sm text-muted-foreground">
                View membership plans and sign up online.
              </p>
            </div>
          </div>
          <div className="flex flex-wrap gap-2">
            {joinPath ? (
              <Button asChild style={{ backgroundColor: accent, borderColor: accent }}>
                <Link to={joinPath}>View plans</Link>
              </Button>
            ) : null}
            {membershipPath ? (
              <Button asChild variant="outline">
                <Link to={membershipPath}>Member portal</Link>
              </Button>
            ) : null}
          </div>
        </CardContent>
      </Card>
    </section>
  );
}
